/**
    Determines whether a given DOM element is visible within the current viewport, with an optional pixel buffer.
    @param elem The DOM element to check.
    @param buffer Extra pixel margin around the viewport boundary.
*/ export default function(elem) {
    var buffer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    var pageX = window.scrollX;
    var pageY = window.scrollY;
    var bounds = elem.getBoundingClientRect();
    var height = bounds.height, left = bounds.left + pageX, top = bounds.top + pageY, width = bounds.width;
    return pageY + window.innerHeight > top + buffer && pageY + buffer < top + height && pageX + window.innerWidth > left + buffer && pageX + buffer < left + width;
}

//# sourceMappingURL=inViewport.js.map